"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanEmbedded = void 0;
const cleanEmbedded = (param) => {
    if (Array.isArray(param)) {
        return param.map(exports.cleanEmbedded);
    }
    if (param && typeof param === 'object') {
        return Object.keys(param).reduce((formatted, key) => {
            if (key === '_embedded') {
                return { ...formatted, ...(0, exports.cleanEmbedded)(param[key]) };
            }
            formatted[key] = (0, exports.cleanEmbedded)(param[key]);
            return formatted;
        }, {});
    }
    return param;
};
exports.cleanEmbedded = cleanEmbedded;
//# sourceMappingURL=format.js.map